export default "__VITE_ASSET__D4vd8nSG__"